import React, { useState, useEffect } from 'react';
import { useLayoutMaster } from '../utils/useLayoutMaster';
import magmaLogo from '../assets/logos/LOGO RR MAGMA.svg';

// ─────────────────────────────────────────────────────────────
// MAGMA HERO SECTION
// ─────────────────────────────────────────────────────────────

export function MagmaHeroSection({ marketData }) {
  const layout = useLayoutMaster();
  const isMobile = layout.isMobile;
  const [intensity, setIntensity] = useState(74);
  const [userCount, setUserCount] = useState(3847);

  useEffect(() => {
    const i1 = setInterval(() => setIntensity(p => Math.max(60, Math.min(94, p + (Math.random() - 0.48) * 3.2))), 1700);
    const i2 = setInterval(() => setUserCount(p => p + Math.floor((Math.random() - 0.3) * 7)), 2400);
    return () => { clearInterval(i1); clearInterval(i2); };
  }, []);

  const columns = [
    {
      label: 'ALTAS · B3',
      color: '#22c55e',
      items: marketData?.topGainers?.slice(0,12).map(t => ({
        sym: t.ticker, val: `R$${t.ult?.toFixed(2)}`, chg: `+${t.var?.toFixed(2)}%`, pos: true,
      })) || [
        { sym: 'CPLE6', val: 'R$11.82', chg: '+4.21%', pos: true },
        { sym: 'ELET3', val: 'R$39.14', chg: '+3.87%', pos: true },
        { sym: 'SUZB3', val: 'R$58.40', chg: '+2.94%', pos: true },
        { sym: 'WEGE3', val: 'R$47.22', chg: '+2.41%', pos: true },
        { sym: 'ITUB4', val: 'R$33.80', chg: '+1.98%', pos: true },
        { sym: 'BBAS3', val: 'R$26.72', chg: '+1.74%', pos: true },
        { sym: 'RENT3', val: 'R$53.10', chg: '+1.42%', pos: true },
        { sym: 'RDOR3', val: 'R$30.64', chg: '+1.21%', pos: true },
        { sym: 'BRFS3', val: 'R$21.40', chg: '+1.08%', pos: true },
        { sym: 'KLBN4', val: 'R$18.92', chg: '+0.96%', pos: true },
      ],
    },
    {
      label: 'BAIXAS · B3', color: '#DC143C',
      items: marketData?.topLosers?.slice(0,12).map(t => ({
        sym: t.ticker, val: `R$${t.ult?.toFixed(2)}`, chg: `${t.var?.toFixed(2)}%`, pos: false,
      })) || [
        { sym: 'MGLU3', val: 'R$1.84',  chg: '-5.13%', pos: false },
        { sym: 'VIIA3', val: 'R$0.72',  chg: '-4.42%', pos: false },
        { sym: 'BRAP4', val: 'R$24.10', chg: '-2.84%', pos: false },
        { sym: 'VALE3', val: 'R$61.14', chg: '-0.87%', pos: false },
        { sym: 'CSNA3', val: 'R$9.28',  chg: '-2.21%', pos: false },
        { sym: 'CSAN3', val: 'R$18.44', chg: '-1.88%', pos: false },
        { sym: 'PRIO3', val: 'R$44.80', chg: '-1.62%', pos: false },
        { sym: 'AZUL4', val: 'R$5.42',  chg: '-1.44%', pos: false },
        { sym: 'HAPV3', val: 'R$3.12',  chg: '-1.22%', pos: false },
        { sym: 'COGN3', val: 'R$2.88',  chg: '-1.10%', pos: false },
      ],
    },
    {
      label: 'CRIPTO · LIVE', color: '#FFB300',
      items: [
        { sym: 'BTC',   val: '$98.422', chg: '+2.84%', pos: true  },
        { sym: 'ETH',   val: '$3.481',  chg: '+1.92%', pos: true  },
        { sym: 'SOL',   val: '$182.40', chg: '+4.21%', pos: true  },
        { sym: 'BNB',   val: '$612.10', chg: '-0.42%', pos: false },
        { sym: 'XRP',   val: '$2.18',   chg: '+1.14%', pos: true  },
        { sym: 'ADA',   val: '$0.892',  chg: '-1.28%', pos: false },
        { sym: 'DOGE',  val: '$0.382',  chg: '+3.14%', pos: true  },
        { sym: 'AVAX',  val: '$38.24',  chg: '+0.88%', pos: true  },
        { sym: 'LINK',  val: '$18.40',  chg: '+1.55%', pos: true  },
        { sym: 'DOT',   val: '$9.14',   chg: '-0.72%', pos: false },
      ],
    },
    {
      label: 'FX · CÂMBIO', color: '#FF6A00',
      items: [
        { sym: 'USD/BRL', val: '5,7421', chg: '-0.32%', pos: false },
        { sym: 'EUR/BRL', val: '6,1280', chg: '+0.11%', pos: true  },
        { sym: 'GBP/BRL', val: '7,2140', chg: '-0.08%', pos: false },
        { sym: 'JPY/BRL', val: '0,0381', chg: '+0.22%', pos: true  },
        { sym: 'CHF/BRL', val: '6,3420', chg: '+0.14%', pos: true  },
        { sym: 'CNY/BRL', val: '0,7920', chg: '-0.18%', pos: false },
        { sym: 'BRENT',   val: '$78.42', chg: '+1.84%', pos: true  },
        { sym: 'OURO',    val: '$2.318', chg: '+0.63%', pos: true  },
        { sym: 'SELIC',   val: '15,00%', chg: '0.00%',  pos: true  },
        { sym: 'S&P 500', val: '5.218',  chg: '+0.31%', pos: true  },
      ],
    },
    {
      color: '#22c55e',
      items: [
        { sym: 'IBOV',   val: '138.421', chg: '+0.42%', pos: true  },
        { sym: 'IFIX',   val: '3.284',   chg: '+0.18%', pos: true  },
        { sym: 'SMLL',   val: '2.184',   chg: '-0.24%', pos: false },
        { sym: 'IDIV',   val: '7.814',   chg: '+0.55%', pos: true  },
        { sym: 'NASDAQ', val: '16.421',  chg: '+0.48%', pos: true  },
        { sym: 'DAX',    val: '18.240',  chg: '+0.22%', pos: true  },
        { sym: 'NIKKEI', val: '38.840',  chg: '-0.14%', pos: false },
        { sym: 'FTSE',   val: '8.214',   chg: '+0.09%', pos: true  },
        { sym: 'CAC',    val: '8.042',   chg: '+0.31%', pos: true  },
        { sym: 'HSI',    val: '17.840',  chg: '-0.62%', pos: false },
      ],
    },
  ];

  return (
    <div style={{
      position: 'relative',
      background: '#03010a',
      overflow: 'hidden',
      borderBottom: '1px solid rgba(102,96,254,0.25)',
      minHeight: 480,
    }}>

      {/* ── LAYER 1: Rolling columns background ── */}
      <div style={{
        position: 'absolute', inset: 0,
        display: 'grid',
        gridTemplateColumns: isMobile ? 'repeat(3, 1fr)' : 'repeat(5, 1fr)',
        gap: 0,
        overflow: 'hidden',
      }}>
        {columns.map((col, ci) => {
          const doubled = [...col.items, ...col.items, ...col.items];
          return (
            <div key={ci} style={{
              overflow: 'hidden',
              borderRight: '1px solid rgba(255,255,255,0.03)',
              fontFamily: "'IBM Plex Mono',monospace",
            }}>
              <div style={{ animation: `bgScroll${ci} ${14 + ci * 3}s linear infinite` }}>
                {doubled.map((item, ri) => (
                  <div key={ri} style={{
                    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                    padding: '8px 12px',
                    borderBottom: '1px solid rgba(255,255,255,0.025)',
                  }}>
                    <span style={{ fontSize: 10, fontWeight: 700, color: 'rgba(255,255,255,0.22)', letterSpacing: '0.04em' }}>{item.sym}</span>
                    <span style={{ fontSize: 10, fontWeight: 700, color: item.pos ? 'rgba(34,197,94,0.35)' : 'rgba(220,20,60,0.35)' }}>{item.chg}</span>
                  </div>
                ))}
              </div>
            </div>
          );
        })}
      </div>

      {/* ── LAYER 2: Gradient overlay ── */}
      <div style={{
        position: 'absolute', inset: 0,
        background: 'linear-gradient(105deg, rgba(3,1,10,0.96) 0%, rgba(3,1,10,0.88) 40%, rgba(3,1,10,0.55) 65%, rgba(3,1,10,0.2) 100%)',
        pointerEvents: 'none',
      }} />

      {/* ── LAYER 3: Purple glow ── */}
      <div style={{ position: 'absolute', top: 0, left: 0, width: '50%', height: '100%', background: 'radial-gradient(ellipse 80% 70% at 5% 85%,rgba(102,96,254,0.35) 0%,transparent 65%)', pointerEvents: 'none' }} />

      {/* ── LAYER 4: Volcano — decorative lava, intentionally kept ── */}
      <div style={{ position: 'absolute', right: 0, bottom: 0, width: isMobile ? '70%' : '42%', height: '100%', opacity: isMobile ? 0.12 : 0.28, pointerEvents: 'none' }}>
        <svg viewBox="0 0 700 480" preserveAspectRatio="xMaxYMax meet" style={{ width: '100%', height: '100%' }}>
          <defs>
            <linearGradient id="hm2" x1="0" x2="0" y1="0" y2="1"><stop offset="0%" stopColor="#0d0a1a"/><stop offset="100%" stopColor="#020202"/></linearGradient>
            <linearGradient id="hlv2" x1="0" x2="0" y1="0" y2="1"><stop offset="0%" stopColor="#a89bff"/><stop offset="50%" stopColor="#6660fe"/><stop offset="100%" stopColor="#3d3a99"/></linearGradient>
            <radialGradient id="hcg2" cx="50%" cy="50%" r="50%"><stop offset="0%" stopColor="#8b87ff" stopOpacity="0.9"/><stop offset="45%" stopColor="#6660fe" stopOpacity="0.4"/><stop offset="100%" stopColor="#6660fe" stopOpacity="0"/></radialGradient>
          </defs>
          <path d="M0,480 L0,370 L120,330 L270,358 L450,315 L610,335 L700,325 L700,480 Z" fill="url(#hm2)" opacity="0.6"/>
          <path d="M0,480 L0,400 L155,400 L310,215 L358,188 L408,215 L575,400 L700,400 L700,480 Z" fill="url(#hm2)"/>
          <ellipse cx="358" cy="190" rx="125" ry="66" fill="url(#hcg2)"/>
          <path d="M356,192 L347,238 L356,288 L348,346 L356,400" stroke="url(#hlv2)" strokeWidth="3.5" fill="none" opacity="0.9"/>
          <path d="M364,192 L380,250 L368,302 L382,400" stroke="url(#hlv2)" strokeWidth="2.5" fill="none" opacity="0.7"/>
          <ellipse cx="358" cy="190" rx="26" ry="8" fill="#a89bff" opacity="0.95"/>
          <ellipse cx="358" cy="190" rx="11" ry="3.5" fill="#e8e6ff" opacity="0.8"/>
          <path d="M344,182 Q316,138 344,92 Q377,48 354,0 L374,0 Q396,56 364,98 Q338,140 370,182 Z" fill="rgba(14,10,35,0.6)"/>
        </svg>
      </div>

      {/* ── LAYER 5: Content ── */}
      <div style={{ position: 'relative', zIndex: 2, maxWidth: 1400, margin: '0 auto', padding: isMobile ? '1.5rem 1rem 1.25rem' : '2.5rem 2.5rem 2rem', display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1.4fr 1fr', gap: isMobile ? '1.25rem' : '2rem', alignItems: 'center', minHeight: isMobile ? 'auto' : 420 }}>

        {/* LEFT — branding */}
        <div>
          <div style={{ fontFamily: "'IBM Plex Mono',monospace", fontSize: 8, fontWeight: 600, letterSpacing: '0.3em', color: 'rgba(255,255,255,0.18)', marginBottom: '0.8rem' }}>
            RELATÓRIO RESERVADO · PLATAFORMA DE DADOS
          </div>

          {/* Magma logo */}
          <div style={{ marginBottom: '0.8rem' }}>
            <img
              src={magmaLogo}
              alt="RR Magma"
              style={{ height: isMobile ? 44 : 64, width: 'auto', display: 'block' }}
            />
          </div>

          <p style={{ fontFamily: "'Plus Jakarta Sans',system-ui,sans-serif", fontSize: 'clamp(14px,1.4vw,18px)', fontWeight: 400, fontStyle: 'italic', color: 'rgba(255,255,255,0.5)', margin: '0 0 0.6rem', lineHeight: 1.3 }}>
            Profundidade de mercado.<br />
            <span style={{ color: 'rgba(255,255,255,0.24)' }}>Em tempo real.</span>
          </p>
          <p style={{ fontFamily: "'IBM Plex Mono',monospace", fontSize: 10, lineHeight: 1.6, color: 'rgba(255,255,255,0.28)', margin: '0 0 1.4rem' }}>
            Order book L2 · COPOM · índices globais · 60k+ artigos RR
          </p>
          <div style={{ display: 'flex', alignItems: 'center', gap: 9 }}>
            <div style={{ display: 'flex' }}>
              {['#6660fe','#8b87ff','#FFB300','#22c55e'].map((c,i) => (
                <div key={i} style={{ width: 22, height: 22, borderRadius: '50%', background: c, border: '2px solid #03010a', marginLeft: i > 0 ? -7 : 0, fontSize: 7, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontWeight: 800, fontFamily: "'IBM Plex Mono',monospace" }}>
                  {['A','B','C','D'][i]}
                </div>
              ))}
            </div>
            <span style={{ fontFamily: "'Plus Jakarta Sans',system-ui,sans-serif", fontSize: 10, fontWeight: 400, color: 'rgba(255,255,255,0.24)' }}>
              <span style={{ color: '#FFB300', fontWeight: 600 }}>{userCount.toLocaleString()}</span> conectados
            </span>
          </div>
        </div>

        {/* CENTER — live ticker columns */}
        {!isMobile && <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 6, height: 360 }}>
          {columns.slice(0,3).map((col, ci) => {
            const doubled = [...col.items, ...col.items, ...col.items];
            return (
              <div key={ci} style={{
                background: 'rgba(4,2,12,0.75)',
                border: `1px solid rgba(255,255,255,0.07)`,
                borderTop: `2px solid ${col.color}`,
                borderRadius: 8,
                overflow: 'hidden',
                backdropFilter: 'blur(8px)',
              }}>
                <div style={{ padding: '7px 10px 6px', borderBottom: '1px solid rgba(255,255,255,0.06)', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <span style={{ fontFamily: "'IBM Plex Mono',monospace", fontSize: 8, fontWeight: 700, letterSpacing: '0.12em', color: col.color }}>{col.label}</span>
                  <span style={{ width: 5, height: 5, borderRadius: '50%', background: col.color, boxShadow: `0 0 5px ${col.color}`, animation: 'pulse 1.5s infinite', display: 'inline-block' }} />
                </div>
                <div style={{ height: 'calc(100% - 32px)', overflow: 'hidden', position: 'relative' }}>
                  <div style={{ animation: `bgScroll${ci} ${12 + ci * 3}s linear infinite` }}>
                    {doubled.map((item, ri) => (
                      <div key={ri} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '6px 10px', borderBottom: '1px solid rgba(255,255,255,0.04)', fontFamily: "'IBM Plex Mono',monospace" }}>
                        <span style={{ fontSize: 10, fontWeight: 700, color: 'rgba(255,255,255,0.7)', letterSpacing: '0.03em' }}>{item.sym}</span>
                        <div style={{ textAlign: 'right' }}>
                          <div style={{ fontSize: 9, color: 'rgba(255,255,255,0.45)' }}>{item.val}</div>
                          <div style={{ fontSize: 9, fontWeight: 700, color: item.pos ? '#22c55e' : '#DC143C' }}>{item.chg}</div>
                        </div>
                      </div>
                    ))}
                  </div>
                  <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, height: 40, background: 'linear-gradient(to top,rgba(4,2,12,0.9),transparent)', pointerEvents: 'none' }} />
                </div>
              </div>
            );
          })}
        </div>}

        {/* Mobile: 2-col ticker strip */}
        {isMobile && (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2,1fr)', gap: 6, height: 180 }}>
            {columns.slice(0,2).map((col, ci) => {
              const doubled = [...col.items, ...col.items];
              return (
                <div key={ci} style={{ background: 'rgba(4,2,12,0.75)', border: `1px solid rgba(255,255,255,0.07)`, borderTop: `2px solid ${col.color}`, borderRadius: 8, overflow: 'hidden' }}>
                  <div style={{ padding: '6px 8px 5px', borderBottom: '1px solid rgba(255,255,255,0.06)', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <span style={{ fontFamily: "'IBM Plex Mono',monospace", fontSize: 7, fontWeight: 700, color: col.color }}>{col.label}</span>
                    <span style={{ width: 4, height: 4, borderRadius: '50%', background: col.color, animation: 'pulse 1.5s infinite', display: 'inline-block' }} />
                  </div>
                  <div style={{ height: 'calc(100% - 28px)', overflow: 'hidden', position: 'relative' }}>
                    <div style={{ animation: `bgScroll${ci} ${12 + ci * 2}s linear infinite` }}>
                      {doubled.map((item, ri) => (
                        <div key={ri} style={{ display: 'flex', justifyContent: 'space-between', padding: '5px 8px', borderBottom: '1px solid rgba(255,255,255,0.04)', fontFamily: "'IBM Plex Mono',monospace" }}>
                          <span style={{ fontSize: 9, fontWeight: 700, color: 'rgba(255,255,255,0.7)' }}>{item.sym}</span>
                          <span style={{ fontSize: 9, fontWeight: 700, color: item.pos ? '#22c55e' : '#DC143C' }}>{item.chg}</span>
                        </div>
                      ))}
                    </div>
                    <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, height: 28, background: 'linear-gradient(to top,rgba(4,2,12,0.9),transparent)', pointerEvents: 'none' }} />
                  </div>
                </div>
              );
            })}
          </div>
        )}

        {/* RIGHT — stats + intensity + alert */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          {/* Intensity */}
          <div style={{ background: 'rgba(6,4,18,0.82)', border: '1px solid rgba(102,96,254,0.2)', borderRadius: 8, padding: '12px 16px', backdropFilter: 'blur(12px)' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 7, fontFamily: "'IBM Plex Mono',monospace", fontSize: 8, letterSpacing: '0.14em' }}>
              <span style={{ color: 'rgba(255,255,255,0.26)' }}>INTENSIDADE</span>
              <span style={{ fontFamily: "'Plus Jakarta Sans',system-ui,sans-serif", fontSize: 11, fontWeight: 600, color: '#FFB300' }}>{Math.round(intensity)}%</span>
            </div>
            <div style={{ height: 4, borderRadius: 3, background: 'rgba(255,255,255,0.06)', overflow: 'hidden' }}>
              <div style={{ height: '100%', width: `${intensity}%`, background: 'linear-gradient(90deg,#3d3a99,#6660fe,#8b87ff,#a89bff,#FFB300)', borderRadius: 3, transition: 'width 0.7s ease' }} />
            </div>
          </div>

          {/* 4-stat grid */}
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 1, border: '1px solid rgba(255,255,255,0.06)', background: 'rgba(255,255,255,0.06)', borderRadius: 8, overflow: 'hidden' }}>
            {[
              { l: 'FONTES',    v: '89',    s: 'sistêmicas', c: '#6660fe' },
              { l: 'COBERTURA', v: 'G20',   s: 'globais',    c: '#8b87ff' },
              { l: 'LATÊNCIA',  v: '<50ms', s: 'live',       c: '#FFB300' },
              { l: 'ATIVOS',    v: '6.4k',  s: 'instrumentos', c: '#8b87ff' },
            ].map(m => (
              <div key={m.l} style={{ background: 'rgba(4,2,12,0.92)', padding: '11px 14px', backdropFilter: 'blur(8px)' }}>
                <div style={{ fontFamily: "'IBM Plex Mono',monospace", fontSize: 7, fontWeight: 700, letterSpacing: '0.14em', color: 'rgba(255,255,255,0.2)', marginBottom: 4 }}>{m.l}</div>
                <div style={{ fontFamily: "'Plus Jakarta Sans',system-ui,sans-serif", fontSize: 20, fontWeight: 600, color: m.c, lineHeight: 1 }}>{m.v}</div>
                <div style={{ fontFamily: "'Plus Jakarta Sans',system-ui,sans-serif", fontSize: 8, fontWeight: 400, color: 'rgba(255,255,255,0.18)', marginTop: 3 }}>{m.s}</div>
              </div>
            ))}
          </div>

          {/* Alert */}
          <div style={{ display: 'flex', alignItems: 'flex-start', gap: 8, background: 'rgba(4,2,12,0.82)', border: '1px solid rgba(102,96,254,0.3)', borderLeft: '4px solid #6660fe', borderRadius: 6, padding: '10px 13px', backdropFilter: 'blur(12px)' }}>
            <div style={{ fontFamily: "'IBM Plex Mono',monospace", fontSize: 7, fontWeight: 800, letterSpacing: '0.12em', color: '#fff', background: '#6660fe', padding: '3px 5px', borderRadius: 2, whiteSpace: 'nowrap', marginTop: 1 }}>● ALERTA</div>
            <div style={{ flex: 1 }}>
              <div style={{ fontFamily: "'Plus Jakarta Sans',system-ui,sans-serif", fontSize: 12, fontWeight: 400, color: 'rgba(255,255,255,0.85)', marginBottom: 3, lineHeight: 1.3 }}>
                {marketData?.headline || 'COPOM corta Selic em 25bps; sinaliza fim do ciclo'}
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span style={{ fontFamily: "'IBM Plex Mono',monospace", fontSize: 8, color: 'rgba(255,255,255,0.28)' }}>Há 4 min · Brasília</span>
                <a href="#" style={{ fontFamily: "'IBM Plex Mono',monospace", fontSize: 8, fontWeight: 700, color: '#FFB300', textDecoration: 'none' }}>LER →</a>
              </div>
            </div>
          </div>

          {!isMobile && <div style={{
            background: 'rgba(4,2,12,0.75)', border: `1px solid rgba(255,255,255,0.07)`,
            borderTop: `2px solid ${columns[3].color}`, borderRadius: 8, overflow: 'hidden',
            flex: 1, backdropFilter: 'blur(8px)',
          }}>
            <div style={{ padding: '7px 10px 6px', borderBottom: '1px solid rgba(255,255,255,0.06)', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <span style={{ fontFamily: "'IBM Plex Mono',monospace", fontSize: 8, fontWeight: 700, letterSpacing: '0.12em', color: columns[3].color }}>{columns[3].label}</span>
              <span style={{ width: 5, height: 5, borderRadius: '50%', background: columns[3].color, animation: 'pulse 1.5s infinite', display: 'inline-block' }} />
            </div>
            <div style={{ height: 120, overflow: 'hidden', position: 'relative' }}>
              <div style={{ animation: `bgScroll3 18s linear infinite` }}>
                {[...columns[3].items, ...columns[3].items, ...columns[3].items].map((item, ri) => (
                  <div key={ri} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '5px 10px', borderBottom: '1px solid rgba(255,255,255,0.04)', fontFamily: "'IBM Plex Mono',monospace" }}>
                    <span style={{ fontSize: 9, fontWeight: 700, color: 'rgba(255,255,255,0.65)' }}>{item.sym}</span>
                    <span style={{ fontSize: 9, fontWeight: 700, color: item.pos ? '#22c55e' : '#DC143C' }}>{item.chg}</span>
                  </div>
                ))}
              </div>
              <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, height: 30, background: 'linear-gradient(to top,rgba(4,2,12,0.9),transparent)', pointerEvents: 'none' }} />
            </div>
          </div>}
        </div>
      </div>

      {/* Bottom edge */}
      <div style={{ height: 3, background: 'linear-gradient(90deg,#3d3a99,#6660fe,#a89bff,#6660fe,#3d3a99)', opacity: 0.6 }} />

      <style>{`
        @keyframes bgScroll0{0%{transform:translateY(0)}100%{transform:translateY(-33.33%)}}
        @keyframes bgScroll1{0%{transform:translateY(0)}100%{transform:translateY(-33.33%)}}
        @keyframes bgScroll2{0%{transform:translateY(0)}100%{transform:translateY(-33.33%)}}
        @keyframes bgScroll3{0%{transform:translateY(0)}100%{transform:translateY(-33.33%)}}
        @keyframes bgScroll4{0%{transform:translateY(0)}100%{transform:translateY(-33.33%)}}
      `}</style>
    </div>
  );
}